import dayjs from 'dayjs';

const one_day_later_date = dayjs().add(1, 'day');

export default {
  /**
   * ローカルストレージにkeyに対応したvalueを保存
   * @param {string} key - ローカルストレージからvalueを取り出す為に使う名前
   * @param {any} value - keyに対応した値
   */
  setStorage(key, value) {
    let data;
    const expire = one_day_later_date;
    data = {
      expire,
      value
    };
    localStorage.setItem(key, JSON.stringify(data));
  },
  /**
   * ローカルストレージにkeyに対応したvalueを取り出す
   * @param {string} key - ローカルストレージからvalueを取り出す為に使う名前
   */
  getStorage(key) {
    let storedValue = localStorage[key];
    if (storedValue === undefined) {
      return undefined;
    }
  
    // パースに失敗した場合はデータを削除する
    try {
      storedValue = JSON.parse(storedValue);
    } catch (SyntaxError) {
      localStorage.removeItem(key);
      return undefined;
    }

    // キャッシュ期間が1年の時代があった
    // 反映したい変更を最大で1年待ちたくない
    // 現在設定しているキャッシュ期間以上にキャッシュ期間を設定されていた場合は現状のキャッシュ期間に上書く
    if (new Date(storedValue.expire) > one_day_later_date) {
      storedValue.expire = one_day_later_date;
      localStorage.setItem(key, JSON.stringify(storedValue));
    }
  
    if (new Date(storedValue.expire) > new Date()) {
      return storedValue.value;
    } else {
      localStorage.removeItem(key);
      return undefined;
    }
  }
}
